var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPercent = function SvgIconPercent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.5 7.125a3.625 3.625 0 1 1 7.25 0 3.625 3.625 0 0 1-7.25 0M7.125 5.5a1.625 1.625 0 1 0 0 3.25 1.625 1.625 0 0 0 0-3.25",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.457 4.543a1 1 0 0 1 0 1.414l-13.5 13.5a1 1 0 0 1-1.414-1.414l13.5-13.5a1 1 0 0 1 1.414 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.875 13.25a3.625 3.625 0 1 0 0 7.25 3.625 3.625 0 0 0 0-7.25m-1.625 3.625a1.625 1.625 0 1 1 3.25 0 1.625 1.625 0 0 1-3.25 0",
    clipRule: "evenodd"
  }))));
};
export default SvgIconPercent;